export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sync-ecommerce-product-list/:pageId',
        component: () => import('@/views/page/company/ecommerce/sync-product/List.vue'),
        name: 'sync-ecommerce-product-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sync-ecommerce-product/:pageId/review/:uploadLogId',
        component: () => import('@/views/page/company/ecommerce/sync-product/Review.vue'),
        name: 'sync-ecommerce-product-review',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/ecommerce-sync-management/:pageId',
        component: () => import('@/views/page/company/ecommerce/sync-management/List.vue'),
        name: 'ecommerce-sync-management',
        meta: {
            requiresAuth: true
        }
    }
]
